"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledForm = exports.FullWidthButton = exports.BorderBuyBoxContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const canvas_box_1 = require("../canvas-box");
const themed_button_1 = require("../themed-button");
const setBorders = (props) => {
    var _a, _b, _c, _d;
    return !props.hideBorders &&
        (0, styled_components_1.css) `
    border: ${(_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.borders) === null || _b === void 0 ? void 0 : _b.buyBox.border};
    border-radius: ${(_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.borders) === null || _d === void 0 ? void 0 : _d.buyBox.borderRadius};
  `;
};
exports.BorderBuyBoxContainer = (0, styled_components_1.default)(canvas_box_1.CanvasContainer) `
  ${setBorders}
`;
exports.FullWidthButton = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
`;
exports.StyledForm = styled_components_1.default.form `
  margin: ${(props) => props.theme.spacings.small} 0 0 0;
`;
